import { RiseOutlined, TagOutlined, PercentageOutlined, InboxOutlined } from '@ant-design/icons';
import { Handshake } from '../../assets/svg';
import { VibrantModuleCard } from './common/ModuleCard';
import { HomeStyledCardWrapper } from './common/AlertAndNotificationCard';

const modules = [
    {
        icon: RiseOutlined,
        title: 'Commercial Planning',
        description: 'Growth analysis, Bump reports, Holistic RGM Simulator, P&L comparison, PVM Analysis',
        color: '270 65% 55%',
        path: '/promo/category-diagnostics/growth-analysis',
    },
    {
        icon: TagOutlined,
        title: 'Strategic Pricing',
        description: 'Price curve, Opportunity identification, Price ladder, Price simulator',
        color: '45 95% 55%',
        path: '/pricing/recommendation/price-simulator',
    },
    {
        icon: InboxOutlined,
        title: 'Portfolio Architecture',
        description: 'Pack architecture, Demand transference, White space analysis, Assortment & Mix, PPA Simulator',
        color: '160 55% 48%',
        path: '/pricing/analytics/price-point',
    },
    {
        icon: PercentageOutlined,
        title: 'Trade Promo Excellence',
        description: 'Promo Scorecard, Investment & ROI Tracker, Best weeks, Trade promo optimization',
        color: '205 65% 52%',
        path: '/promo/analytics/promo-score-card',
    },
    {
        icon: Handshake,
        title: 'Trade Architecture',
        description: 'Profit pool overview, Drivers of Profit growth, P4P Performance, P4P Simulator',
        color: '330 65% 52%',
        path: '/trade-architecture/profit-pool-overview',
    },
];

export const VibrantPlanningEngineSection = () => {
    return (
        <HomeStyledCardWrapper bordered={false}>
            <h3 className="text-lg font-semibold text-gray-800 mb-6 m-0">
                AI Intelligence Studio{' '}
                <span className="text-sm text-gray-500 font-normal">— Self-serve analytics & exploration</span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
                {modules.map((module, index) => (
                    <VibrantModuleCard key={index} {...module} />
                ))}
            </div>
        </HomeStyledCardWrapper>
    );
};
